import { errorMessageByField } from 'common/utils/hook-form'
import { Controller, Control, FieldErrors } from 'react-hook-form'

import { TextField, InputAdornment, Typography } from '@mui/material'

interface TextFieldWithUnitProps {
  name: string
  control: Control<any>
  errors: FieldErrors
  placeholder?: string
  unit?: string
}

const TextFieldWithUnit = ({
  name,
  control,
  errors,
  placeholder,
  unit,
}: TextFieldWithUnitProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          placeholder={placeholder}
          error={!!errors[name]}
          helperText={errorMessageByField(name, errors)}
          fullWidth
          InputProps={{
            sx: {
              height: '40px',
              '& input': {
                paddingRight: unit ? '60px' : undefined, // space for adornment
              },
            },
            endAdornment: unit && (
              <InputAdornment
                position="end"
                sx={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  height: '2.5rem',
                  maxHeight: '5rem',
                  backgroundColor: 'rgba(0, 0, 0, 0.02)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0 11px',
                  borderTopRightRadius: 8,
                  borderBottomRightRadius: 8,
                  borderLeft: '1px solid #D9D9D9',
                }}
              >
                <Typography sx={{ color: '#000000', fontSize: '0.875rem' }}>{unit}</Typography>
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  )
}

export default TextFieldWithUnit
